export const REFERRAL_PROGRAM_PAGE_URL = '/cabinet/referral';
